import * as valid from "lib/valid"
/**
 * Apply a prefix to path values
 */
export function PrefixPath(prefix: string, path: string): string {
	return `${prefix}${path}`
}

type pathValue = string | ((...args: any[]) => string)

/**
 * Applies a prefix to all paths in the provided path object
 */
export function AppendPrefixToPaths<T extends { [key: string]: pathValue }>(
	paths: T,
	prefix: string
): T {
	return Object.fromEntries(
		/* eslint-disable-next-line*/
		//@ts-ignore
		Object.entries(paths).map(([key, value]) => {
			if (valid.IsFunc(value)) {
				return [key, (...args: any[]) => PrefixPath(prefix, value(...args))]
			}
			return [key, PrefixPath(prefix, value)]
		})
	)
}
